interface Props {
  total: number;
  showAll: boolean;
  onToggle: () => void;
}

export function ShowAllButton({total, showAll, onToggle}: Props) {
  return (
    <button
      onClick={onToggle}
      className='mt-2 text-sm text-iq-blue hover:underline font-medium'
    >
      {showAll ? 'Show fewer topics' : `View all ${total} topics`}
    </button>
  );
}
